var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArchivosElaboracionPropuesta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 58 58",
    style: {
      enableBackground: "new 0 0 58 58"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EFCE4A"
    },
    d: "M46.324,52.5H1.565c-1.03,0-1.779-0.978-1.51-1.973l10.166-27.871 c0.184-0.682,0.803-1.156,1.51-1.156H56.49c1.03,0,1.51,0.984,1.51,1.973L47.834,51.344C47.65,52.026,47.031,52.5,46.324,52.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F4EFDC"
    },
    d: "M10.221,22.656c0.184-0.683,0.803-1.156,1.51-1.156H53v-7H9l-6,6v21.953L10.221,22.656z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBBA16"
    },
    d: "M23.571,10.5L20,5.5H1.732C0.776,5.5,0,6.275,0,7.232V49.96c0.069,0.002,0.138,0.006,0.205,0.01 L3,42.349V20.5l2-2v-8H23.571z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D1BF86"
    },
    points: "5,10.5 5,18.5 9,14.5 51,14.5 51,10.5 "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 19.5,
    style: {
      fill: "#BFBAA5"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35,
    y: 19.5,
    style: {
      fill: "#BFBAA5"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42,
    y: 19.5,
    style: {
      fill: "#BFBAA5"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14,
    y: 19.5,
    style: {
      fill: "#BFBAA5"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 21,
    y: 19.5,
    style: {
      fill: "#BFBAA5"
    },
    width: 2,
    height: 2
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CEC9AE"
    },
    points: "9,20.5 9,14.5 3,20.5 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchivosElaboracionPropuesta);
export default __webpack_public_path__ + "static/media/archivos_elaboracion_propuesta.1a7ad04f0138d231666a2f84d07e08c6.svg";
export { ForwardRef as ReactComponent };